$(document).ready(function () {
  $("#modal-vip").on("shown.bs.modal", function () {
    $(this).find(".modal-body").css("opacity", 1);
  });

  $("#modal-vip").on("hide.bs.modal", function () {
    $(this).find(".modal-body").css("opacity", 0);
  });
});
